import './index.scss'
$(".section5 ul li").eq(0).addClass('active');
$(".section5 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text").slideToggle();
})